import store from '~/store'
import _ from 'underscore'

const AuthHelper = {
    hasPermission(required_permissions) {
        let user_permissions = store.state.user_permissions;
        // Use _.every instead of _.each for better performance
        return _.every(required_permissions, (permission)=> {
            return _.includes(user_permissions, permission);
        })
    }
};

export default AuthHelper